import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keys',
    standalone: false
})
export class KeysPipe implements PipeTransform {

    transform(value, args: string[]): any {
        if (value) {
            return Object.keys(value);
        }
        return [];
    }
}
